export default "__VITE_ASSET__N3SK4hg0__"